<template>
      <div class="card">
        <v-form  ref="form">
          <div class="img-wrapper">
            <img :src="require('@/assets/Email.gif')" style="height:160px;width:250" alt="Check Email" />
          </div>
          <div class="check mb-3 text-center">Please Check your email</div>
          <div class="text-disabled font-weight-bold text-center" style="font-size: 12px; font-family: Poppins;">
            We have sent you a link to reset the password to your registered email ID {{ email }}
          </div>
          <div class="my-4 pt-2 pl-1 receive">
            Didn’t receive the email? <a @click="resend" class="resend">Click here </a> to resend.
          </div>
          <div> 
            <div class="pa-0 pt-2" align="center">
              <v-btn
                block
                color="#D0103A"
                size="large"
                 @click="$router.push('/')"
                class="text-none text-white log-btn"
                >
                <v-icon class=" mr-2">mdi-arrow-left</v-icon>
                Back to Login</v-btn
              >
            </div>
            <!-- <span class="text-body text-disabled font-weight-medium">
              <v-icon @click="$router.push('/')" class="resend">mdi-arrow-left</v-icon>
              &nbsp;&nbsp;Back to log in
            </span> -->
          </div>
        
      </v-form>
      </div>
</template>

<script>
import ResetPasswordService from "@/api/service/ResetPasswordService";

export default {
  data() {
    return {
      email: this.$route.query.email || "", 
    };
  },
  methods: {
    async resend() {
      try {
        const data = JSON.parse(localStorage.getItem("PASSWORD_DATA"));
        if (data) {
          await ResetPasswordService.forgotPassword(data);
        } else {
          console.warn("No password data found in localStorage.");
        }
      } catch (error) {
        console.error("Error resending email:", error);
      }
    },
  },
};
</script>

<style scoped>
.img-wrapper {
  display: flex;
  justify-content: center;
}
>>>.v-field--error:not(.v-field--disabled) .v-field__prepend-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__clearable > .v-icon {
    color: #5e5f60 !important;
}
</style>
